import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { B3Comfortmode, J1RightarrowD } from '@e3dc-react/icons'
import { ChargingSessionModel } from '../../models/charging-sessions.model'
import { ChargingSessionStatusChip } from '../ChargingSessionStatusChip'
import { format } from '@e3dc-react/shell/Libs/date'
import { getCurrencyValue } from '../../../shared/utils/currency-value'
import { getLocalizedNumber } from 'src/Libs/languages/functions/default'

interface Props {
  chargingSession: ChargingSessionModel
}

export const ChargingSessionMobileTableRowItem: React.FC<Props> = ({ chargingSession }) => {
  const { t } = useCustomTranslation()

  const startAtLabel = format(new Date(chargingSession.startDateTime), t('common.format.date-fns-date-time'))

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
      }}
    >
      <Stack width="100%">
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
          <Typography variant="h5" sx={{ gridColumn: 1, gridRow: 1 }}>
            {startAtLabel}
          </Typography>
          <ChargingSessionStatusChip status={chargingSession.status} />
        </Stack>

        <Stack direction="row" alignItems="center" sx={{ position: 'relative' }}>
          <Typography variant="body2">
            {t('common.format.kwh', {
              value: getLocalizedNumber(chargingSession.consumptionKWh),
            })}
          </Typography>

          <Stack
            direction="row"
            spacing={1}
            sx={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              alignItems: 'center',
            }}
          >
            <B3Comfortmode />
            <Typography>
              {t('common.format.percentageValue', {
                value: getLocalizedNumber(chargingSession.solarEnergyRatio * 100),
              })}
            </Typography>
          </Stack>

          <Box sx={{ marginLeft: 'auto' }}>
            <Typography variant="body2">{getCurrencyValue(chargingSession.totalCost ?? 0, chargingSession.currencyCode)}</Typography>
          </Box>
        </Stack>
      </Stack>

      <Box sx={{ paddingLeft: 0.5, alignSelf: 'center' }}>
        <J1RightarrowD />
      </Box>
    </Box>
  )
}
